import { IoMdClose } from 'react-icons/io';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  height: 100%;
`;

export const IconClose = styled(IoMdClose)`
  position: absolute;
  top: 2rem;
  right: 2rem;
  cursor: pointer;
  color: #000000;

  transition: 180ms ease-in;

  &:hover {
    background: rgba(0, 0, 0, 0.08);
    border-radius: 50%;
  }
`;
